<template>
  <v-card class="ma-2">
    <v-card-title>CONDICIONES DE GARANTÍA</v-card-title>
    <v-card-text>

      No está cubierto por la garantía ninguno de los gastos ocasionados por fallos de instalación o uso indebido del
      equipo. Dicha garantía no amparará las averías generadas por motivos ajenos a la fabricación, roturas por golpes,
      variaciones en la tensión de alimentación, fugas de gas, conexiones eléctricas deficientes o incorrectas, falta de
      mantenimiento, variaciones de los parámetros indicados por el fabricante. Para más detalles le agradeceríamos que
      consultase las condiciones de garantía del producto en cuestión.

    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "Guarantee"
}
</script>

<style scoped>

</style>